export default {
  selection: {
    makeSelectionToShowDetails: {
      notes: 'Shown when no panels are selected in the panel selection view',
      message: 'Make a selection to show additional details.',
    },
    multipleValues: {
      notes: 'Shown when selected panels have different values for a property',
      message: 'Mixed',
    },
  },
  screeningMedia: {
    dialog: {
      title: {
        notes: 'Title for the screening media selection dialog',
        message: 'Select screening media',
      },
    },
    overwriteDialog: {
      title: {
        notes:
          'Title for the dialog confirming that placing a screening media will replace panels outside the selection',
        message: 'Replace covered panels?',
      },
      message: {
        notes:
          'Message explaining that the chosen screening media extends over positions held by other panels, which will be removed',
        message:
          'The selected screening media covers positions outside your selection. Placing it will replace the following panels:',
      },
      confirm: {
        notes: 'Confirm button label in the replace covered panels dialog',
        message: 'Replace',
      },
    },
    model: {
      color: {
        notes:
          'Name of the screening media dialog column showing the color the media is drawn with in the panel layout',
        message: 'Color',
      },
      apertureWidth: {
        notes: 'Screening media property aperture width',
        message: 'Aperture width',
      },
      apertureType: {
        notes: 'Screening media property aperture type',
        message: 'Aperture type',
      },
      articleNumber: {
        notes: 'Screening media property article number',
        message: 'Article number',
      },
      height: {
        notes: 'Screening media property height',
        message: 'Height',
      },
      included: {
        notes:
          'Column header in the screening media dialog for the number of panels that use the media, counted across both displayed layouts',
        message: 'Included',
      },
      materialType: {
        notes: 'Screening media property material type',
        message: 'Material type',
      },
      measurementSystem: {
        notes: 'Screening media property measurement system',
        message: 'Measurement system',
        values: {
          metric: {
            notes: 'Metric units',
            message: 'Metric',
          },
          us: {
            notes: 'US units',
            message: 'US Customary',
          },
        },
      },
      quantity: {
        notes: 'Screening media property quantity',
        message: 'Quantity',
      },
      size: {
        notes:
          'Screening media size in deck grid cells, formatted as width x height, e.g. 1x2',
        message: 'Size',
      },
      thickness: {
        notes: 'Screening media property thickness',
        message: 'Thickness',
      },
      weight: {
        notes: 'Screening media property gross weight',
        message: 'Weight',
      },
      width: {
        notes: 'Screening media property width',
        message: 'Width',
      },
      workingDepth: {
        notes: 'Screening media property working depth',
        message: 'Working depth',
      },
    },
  },
  bom: {
    showRemoved: {
      notes:
        'Button above the bill of material of a screen activity that also lists the panels the activity removes from the deck',
      message: 'Unhide removed materials',
    },
    hideRemoved: {
      notes:
        'Button above the bill of material of a screen activity that hides the panels the activity removes from the deck again',
      message: 'Hide removed materials',
    },
    componentType: {
      panels: {
        notes:
          'Component type of the panel rows in the bill of material, also the header of their group',
        message: 'Panels',
      },
      otherComponents: {
        notes:
          'Component type of the rows for other components (parts such as bolts and clamps) in the bill of material, also the header of their group',
        message: 'Other components',
      },
    },
    columns: {
      componentType: {
        notes: 'Bill of material column header for the component type',
        message: 'Component type',
      },
      description: {
        notes:
          'Bill of material column header showing the material type of a panel or the description of another component',
        message: 'Type / description',
      },
      replacements: {
        notes:
          'Bill of material column header for how many of the components were replaced during the screen activity',
        message: 'Replacements',
      },
      change: {
        notes:
          'Bill of material column header for the change in quantity compared with the parent config or the deck before the activity',
        message: 'Qty change',
      },
    },
    addRow: {
      notes:
        'Button in the bill of material that opens a dialog for adding other components',
      message: 'Add row',
    },
    removeDialog: {
      title: {
        notes:
          'Title of the dialog confirming that an other component is removed from the bill of material',
        message: 'Remove other component?',
      },
      message: {
        notes:
          'Message of the dialog confirming that an other component is removed from the bill of material',
        message: 'The component and its quantities are removed from the BOM.',
      },
    },
    editQuantity: {
      notes:
        'Tooltip of the button that opens the quantity editor for an other component in the bill of material',
      message: 'Edit quantity',
    },
    quantityFor: {
      notes:
        'Caption in the quantity editor of the bill of material; name is the description of the other component',
      message: 'Quantity for {{name}}',
    },
    invalidAmount: {
      notes:
        'Error shown under a quantity or replacements field in the bill of material when the value is not a whole number of zero or more',
      message: 'Enter a whole number, 0 or more',
    },
  },
  otherComponents: {
    dialog: {
      title: {
        notes:
          'Title of the dialog for adding other components to the bill of material',
        message: 'Add other component',
      },
    },
    model: {
      articleNumber: {
        notes: 'Other component property article number',
        message: 'Article number',
      },
      description: {
        notes: 'Other component property description',
        message: 'Description',
      },
      weight: {
        notes: 'Other component property weight',
        message: 'Weight',
      },
    },
  },
};
